export default __webpack_public_path__ + "052d6f2f54781063ac5cbf01a09994e0.png";